const BRANDS = {
  kazo: { key: "kazo", name: "KAZO", logo: "/kazo-logo.png", logoWhite: "/kazo-logo-white.png", hero: "/kazo-store.jpg", accent: "#000000", logoClass: "h-5", loginLogoClass: "h-8", weekLabel: "KAZO weeks" },
};

const q = new URLSearchParams(window.location.search).get("brand");
if (q && BRANDS[q]) localStorage.setItem("sis_brand", q);
if (q === "reset") localStorage.removeItem("sis_brand");
export const brand = BRANDS[localStorage.getItem("sis_brand")] || BRANDS.kazo;
document.documentElement.classList.add(`brand-${brand.key}`);
